<template>
  <div>
    <ul class="learn-area">
      <li
        v-for="(item, index) in learnBanners"
        :key="index">
        <a
          :href="item.keyword ? item.keyword : 'javascript:void(0);'"
          target="_blank">
          <h3>{{ item.name }}</h3>
          <img :src="fixImagePath(item.imageURL)">
          <div class="mask"></div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'MallLean',
  computed: {
    ...mapState('config', ['learnBanners'])
  },
  methods: {
    fixImagePath(url) {
      if (url.indexOf('http://') > -1) {
        return url
      }
      return `${Vue.env.host.file}${url}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .learn-area{
    overflow: hidden;
    margin-left: -6px;
    margin-right: -6px;
    padding-bottom: 32px;
    li{
      width: 25%;
      padding: 0 6px;
      float: left;
      a{
        position: relative;
        display: block;
        text-align: center;
        color: #ffffff;
        height: auto;
        font-size: 16px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100%;
        img{
          display: block;
          width: 100%;
          height: auto;
        }
        h3{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 99;
          opacity: 0;
          -webkit-transition: all 0.2s;
          transition: all 0.2s;
        }
        .mask{
          opacity: 0;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-color: rgba(0, 0, 0, 0.5);
          -webkit-transition: all 0.2s;
          transition: all 0.2s;
          z-index: 9;
        }
        &:hover{
          h3,.mask{
            opacity: 1;
          }
        }
      }
    }
  }
</style>
